import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const RolesIcon = ({
  className,
  ...props
}: {
  className?: string;
} & SvgIconProps) => (
  <SvgIcon
    className={className}
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 18 18"
    width="18"
    height="18"
    fill="none"
    {...props}
  >
    <path
      d="M4.5 16.4991V2.99915C4.5 2.60132 4.65804 2.21979 4.93934 1.93849C5.22064 1.65718 5.60218 1.49915 6 1.49915H12C12.3978 1.49915 12.7794 1.65718 13.0607 1.93849C13.342 2.21979 13.5 2.60132 13.5 2.99915V16.4991H4.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4.50011 9H3.00011C2.60228 9 2.22075 9.15804 1.93945 9.43934C1.65814 9.72064 1.50011 10.1022 1.50011 10.5V15C1.50011 15.3978 1.65814 15.7794 1.93945 16.0607C2.22075 16.342 2.60228 16.5 3.00011 16.5H4.50011"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M13.5 6.75H15C15.3978 6.75 15.7794 6.90804 16.0607 7.18934C16.342 7.47064 16.5 7.85218 16.5 8.25V15C16.5 15.3978 16.342 15.7794 16.0607 16.0607C15.7794 16.342 15.3978 16.5 15 16.5H13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.49989 4.5H10.4999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.49989 7.50085H10.4999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.49989 10.4991H10.4999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.49989 13.5H10.4999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
